module.exports = __webpack_public_path__ + "static/14.2_the_birth_of_christianity-0fd1e7a4bfc0a33aaa60b862180409ae.pdf";